import { ref } from '@vue/composition-api';
import usePeerConnection from '@/compositions/usePeerConnection';

const tracks = ref([]);
const videoTrack = ref({});
const oldTracks = ref([]);

export default function useTracks() {
  const { removeTracksFromConnection } = usePeerConnection();

  function addTrack(track) {
    tracks.value.push(track);
  }

  function removeTracks() {
    tracks.value = [];
  }

  function findSenderByKind(kind) {
    return tracks.value.find((s) => s.track.kind === kind);
  }

  function removeTrack(kind) {
    const sender = findSenderByKind(kind);
    // eslint-disable-next-line no-unused-expressions
    sender?.track?.stop();
    tracks.value = tracks.value.filter((s) => s.track.kind !== kind);
    removeTracksFromConnection([sender]);
  }

  function stopAllTracks() {
    for (let i = 0; i < tracks.value.length; i++) {
      const sender = tracks.value[i];
      // eslint-disable-next-line no-unused-expressions
      sender?.track?.stop();
    }
    for (let i = 0; i < oldTracks.value.length; i++) {
      const track = oldTracks.value[i];
      // eslint-disable-next-line no-unused-expressions
      track?.stop();
    }
    tracks.value = [];
    oldTracks.value = [];
  }

  function setVideoTrack(track) {
    videoTrack.value = track;
  }

  async function deactivateTrack(kind) {
    const sender = findSenderByKind(kind);
    if (!sender) {
      return false;
    }
    sender.track.enabled = false;
    return true;
  }

  async function stopTrack(kind) {
    const sender = findSenderByKind(kind);

    if (!sender) {
      return false;
    }

    await sender.track.stop();
    sender.track.dispatchEvent(new Event('ended'));
    return true;
  }

  async function replaceAndStopTrack(track) {
    const sender = findSenderByKind(track.kind);
    if (!sender) {
      return;
    }
    await sender.track.stop();
    sender.replaceTrack(track);
  }

  async function replaceTrack(track) {
    const sender = findSenderByKind(track.kind);

    if (!sender) {
      return null;
    }
    const oldTrack = sender.track;
    sender.replaceTrack(track);
    oldTracks.value.push(oldTrack);
    return oldTrack;
  }

  return {
    addTrack,
    removeTracks,
    stopTrack,
    deactivateTrack,
    replaceTrack,
    setVideoTrack,
    findSenderByKind,
    removeTrack,
    stopAllTracks,
    videoTrack,
    tracks,
    oldTracks,
    replaceAndStopTrack,
  };
}
